import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const RouteHistoryContext = createContext([]);

export const RouteHistoryProvider = ({ children }) => {
  const location = useLocation();
  const [historyStack, setHistoryStack] = useState([]);

  useEffect(() => {
    setHistoryStack((prev) => [...prev, location.pathname]);
  }, [location]);

  return (
    <RouteHistoryContext.Provider value={historyStack}>
      {children}
    </RouteHistoryContext.Provider>
  );
};

export const useRouteHistory = () => useContext(RouteHistoryContext);
